import { TAsset } from '@types';
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAppDispatch } from '@/store';
import { setDesign } from '../../../actions/pdp.actions';

const useAsset = () => {
  const dispatch = useAppDispatch();
  const { details = {}, miyo, design } = useSelector((state: any) => state.pdpItem);

  const { itemId } = details || {};
  const { partnerConfig = {}, preview: config } = miyo || {};

  const setAsset = useCallback(
    (asset: TAsset) => {
      const assetId = asset?.id;
      if (!!assetId && !!config?.[0]) {
        const {
          face,
          preview: { width, height },
        } = config[0];

        console.log('setDesign')
        dispatch(
          setDesign({
            itemId,
            printType: 'single',
            graphicType: 'engraved',
            faces: [
              {
                face,
                width,
                height,
                elements: [
                  {
                    elementType: 'artwork',
                    assetId,
                    data: assetId,
                    id: 1,
                    fixed: !!partnerConfig?.partner?.limitAssets,
                  },
                ],
              },
            ],
          })
        );
      }
    },
    [config]
  );

  useEffect(() => {
    const { assetId: assetIdQueryParam } = Object.fromEntries(
      new URLSearchParams(window.location.search).entries()
    );

    if (!assetIdQueryParam) return;

    const activeAsset =
      partnerConfig?.assets?.find((asset: TAsset) => asset.id === parseInt(assetIdQueryParam)) ??
      partnerConfig?.assets?.[0];

    const alreadySet = !!design; // && !!design.faces.find(f => f.elements.find(e => e.assetId === activeAsset.id));

    if (!alreadySet) {
      setAsset(activeAsset);
    }
  }, []);

  return {
    asset: miyo?.asset,
    setAsset,
  };
};

export default useAsset;
